<app-button
  (clicked)="onInviteMembersClicked()"
  [dataTestId]="'button_invitemembers'"
  [isDisabled]="hasRoomBeenAbandoned() || isDisabled()"
  onKeyUp="dialogService.open(dialog)"
  text="Weitere Personen"
  tooltip="Fügen Sie dem Chat weitere Personen hinzu"
  [customWidth]="customBtnWidth()"
  tooltipPosition="left">
  <mat-icon svgIcon="add-member"></mat-icon>
</app-button>

<ng-template #dialog>
  <app-base-invite (confirmClick)="invite($event)" [room]="room"></app-base-invite>
</ng-template>
